module.exports = __webpack_public_path__ + "img/client-place-des-arts.096338c9.webp";